<template>
  <div>
    <v-card
      flat
      class="rounded-lg mt-5 textLight--text"
      :style="$vuetify.breakpoint.md ? 'font-size: 14px !important;' : ''"
    >
      <v-row align="center" class="pa-3 pa-md-0">
        <v-col cols="12" md>
          <div>
            <div class="d-flex flex-row justify-start flex-md-row align-center">
              <!--              <v-img
                class="rounded-lg ms-0 ms-md-3 no-filter"
                height="45"
                max-width="45"
                :src="
                  registrationData.employee &&
                  registrationData.employee.user &&
                  registrationData.employee.user.avatar
                    ? getImage(registrationData.employee.user.avatar)
                    : require('@/app/user-module/assets/images/user-placeholder.png')
                "
                :lazy-src="
                  require('@/app/user-module/assets/images/user-placeholder.png')
                "
                cover
              />-->

              <div
                class="ms-0 ms-md-3 me-0 me-md-3 align-center"
                style="text-align: start"
              >
                <div class="ma-0 text-ellipse-2">
                  <span>
                    {{
                      registrationData.employee &&
                      registrationData.employee.user &&
                      registrationData.employee.user.firstName
                        ? registrationData.employee.user.firstName
                        : "-"
                    }}
                    {{
                      registrationData.employee &&
                      registrationData.employee.user &&
                      registrationData.employee.user.lastName
                        ? registrationData.employee.user.lastName
                        : ""
                    }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md>
          <div class="text-ellipse-2 text-start">
            {{
              registrationData.training && registrationData.training.title
                ? getLocalisedValue(registrationData.training.title)
                : "-"
            }}
          </div>
        </v-col>
        <v-col cols="12" md>
          <div class="text-ellipse-2 text-start">
            {{
              registrationData.trainer &&
              registrationData.trainer.user &&
              registrationData.trainer.user.firstName
                ? `${registrationData.trainer.user.firstName || ""} ${
                    registrationData.trainer.user.lastName || ""
                  }`
                : "-"
            }}
          </div>
        </v-col>
        <v-col cols="12" md>
          <div class="text-ellipse-2 text-start">
            {{
              registrationData.organization &&
              registrationData.organization.name
                ? getLocalisedValue(registrationData.organization.name)
                : "-"
            }}
          </div>
        </v-col>
        <v-col cols="6" md="auto">
          <div
            class="d-flex justify-start justify-md-center align-center"
            :style="$vuetify.breakpoint.mdAndUp ? 'width: 110px' : ''"
          >
            <span
              :class="
                registrationData.status === 'REGISTERED'
                  ? 'primary--text'
                  : registrationData.status === 'COMPLETED'
                  ? 'green--text'
                  : registrationData.status === 'THIRDPARTY'
                  ? 'orange--text'
                  : ''
              "
              >{{ formatStatus(registrationData.status) }}</span
            >
          </div>
        </v-col>

        <v-col cols="6" md="auto">
          <!--@deprecated payment status replaced with employee id-->
          <!--          <div
            class="d-flex justify-end justify-md-center align-center"
            v-if="registrationData.invoice"
            :style="$vuetify.breakpoint.mdAndUp ? 'width: 80px' : ''"
          >
            <span
              :class="
                registrationData.invoice.status === 'PAID'
                  ? 'green&#45;&#45;text'
                  : registrationData.invoice.status === 'UNPAID'
                  ? 'red&#45;&#45;text'
                  : 'primary&#45;&#45;text'
              "
            >
              {{
                registrationData.invoice.status
                  ? registrationData.invoice.status.charAt(0).toUpperCase() +
                    registrationData.invoice.status.slice(1).toLowerCase()
                  : "-"
              }}
            </span>
          </div>-->

          <div
            :style="$vuetify.breakpoint.mdAndUp ? 'width: 80px' : ''"
            class="d-flex justify-end justify-md-center align-center"
          >
            {{
              registrationData.employee && registrationData.employee.user
                ? registrationData.employee.user.civilIdOrPassport || "-"
                : "-"
            }}
          </div>
        </v-col>

        <v-col cols="6" md="auto">
          <div
            class="text-start text-md-center"
            :style="$vuetify.breakpoint.mdAndUp ? 'width: 110px' : ''"
          >
            {{
              registrationData.startDate
                ? moment(parseInt(registrationData.startDate)).format(
                    "DD MMM YYYY"
                  )
                : "-"
            }}
          </div>
        </v-col>

        <v-col cols="6" md="auto">
          <div
            class="text-end text-md-center"
            :style="$vuetify.breakpoint.mdAndUp ? 'width: 110px' : ''"
          >
            {{ generateCertificateExpiryDate(registrationData) }}
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },

  props: {
    registrationData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatStatus(status) {
      if (!status) return "-";
      if (status === "THIRDPARTY") return "ThirdParty";
      return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
    },
  },
};
</script>
